import React from "react";
import PropTypes from "prop-types";

import CardForm from "./CardForm";
import PaypalPaymentContent from "./PaypalPaymentContent";

import { PAYMENT_METHODS } from "./constants";

const PaymentInfo = ({
    paymentMethod,
    form,
    response,
    handleFormChange,
    showSavedCard
}) => {
    let content = null;

    if (paymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
        content = (
            <CardForm
                form={form}
                response={response}
                handleFormChange={handleFormChange}
                showSavedCard={showSavedCard}
            />
        );
    }

    if (paymentMethod === PAYMENT_METHODS.PAYPAL) {
        content = <PaypalPaymentContent />;
    }

    return content;
};

PaymentInfo.propTypes = {
    paymentMethod: PropTypes.string.isRequired,
    showSavedCard: PropTypes.bool.isRequired,
    response: PropTypes.object,
    form: PropTypes.object,
    handleFormChange: PropTypes.func.isRequired
};

export default PaymentInfo;
